import { useLoadScript } from "@react-google-maps/api";

const library = "places"

export const GoogleMapsProvider = ({ children }) => {
  const { isLoaded } = useLoadScript({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyB4aVWmGDuo4c86mpJGIxMbRZ0MtozhbxE",
    libraries: [library],
  });

  return children;
};
